/**
 * Frontend copy of the fixed Clearance Form layout (BRG/HR/LA/1.1).
 * Mirrors backend src/models/ClearanceForm.js SECTION_TEMPLATE. Used for
 * rendering labels, per-section extra inputs, and the print view. The stored
 * document carries the actual values; this only drives presentation.
 */

export const CLEARANCE_REASONS = [
    { value: 'vacation', label: 'Vacation' },
    { value: 'final-exit', label: 'Final Exit' },
    { value: 'duty-transfer', label: 'Duty Transfer' },
    { value: 'other', label: 'Other' }
];

// Extra (non line-item) inputs each section shows above its table.
// type: 'date' | 'yesno' | 'text'
export const SECTION_META_FIELDS = {
    department: [
        { key: 'workHandedOver', label: 'Work Handed Over Document', type: 'yesno' },
        { key: 'attendanceReport', label: 'Attendance Report', type: 'yesno' },
        { key: 'lastWorkingDate', label: 'Last Working Date', type: 'date' }
    ],
    accommodation: [
        { key: 'roomVacatingDate', label: 'Room Vacating Date', type: 'date' }
    ],
    finance: [],
    it: [],
    admin: [],
    hr: []
};

// Sections that show a free-text "Remarks / Comments" box at the end (below the
// line-item table). Stored in section.meta.remarks — `meta` is Mixed on the
// backend, so this needs no schema change.
export const SECTION_REMARKS = ['department', 'finance', 'it', 'admin'];

export const SECTION_TEMPLATE = [
    {
        key: 'department',
        title: 'Department Clearance',
        lineItems: [
            'Cash Bill Pending/ Receivables',
            'Account Balance Confirmation',
            'Fuel Allowance',
            'Cash Advances/ Loans',
            'Invoices/ PV Books/ RV Books/ Deposit Cards/ Cheque Books/ Bank Cards/ POS',
            'Keys / Vehicle Keys',
            'Files, Binders, etc.'
        ]
    },
    {
        key: 'accommodation',
        title: 'Accommodation Clearance',
        lineItems: [
            'Bed, Pillow, Blankets, Bed Sheets',
            'Cot, Plywood',
            'Arrangement of belongings',
            'Keys',
            'Mess, Utility bill settlement, if any',
            ''
        ]
    },
    {
        key: 'finance',
        title: 'Finance Department Clearance',
        lineItems: [
            'Receivables',
            'Payables',
            'Invoices/ PV Books/ RV Books/ Deposit Cards/ Cheque Books/ Bank Cards/ POS',
            'Credit Applications (Pending Approvals Status)',
            'Financial Documents (Guarantee Cheques, etc.)',
            'Customer Ledger Confirmation',
            'Bank Access Reset'
        ]
    },
    {
        key: 'it',
        title: 'IT Department Clearance',
        lineItems: [
            'Adler User Reset',
            'Email Forwarding/ Password Reset',
            'Mobile Phone/ Tabs & Accessories',
            'Laptop/ PC Accessories',
            ''
        ]
    },
    {
        key: 'admin',
        title: 'Admin Department Clearance',
        lineItems: [
            'Vehicle Violations',
            'Country Exit Permit/ Other Fines, If Any',
            'Business Cards/ Brochures/ Letterheads/ Stationery, etc.',
            'Keys (Vehicle, Room, etc.)',
            ''
        ]
    },
    {
        key: 'hr',
        title: 'HR Department Clearance',
        lineItems: [
            'Duty Handover',
            'Uniform Handover',
            'Official WhatsApp Group Removal',
            ''
        ]
    }
];

export const REASON_LABEL = CLEARANCE_REASONS.reduce((acc, r) => {
    acc[r.value] = r.label;
    return acc;
}, {});
